export default {
  bind(el, binding) {
    el.addEventListener("keypress", event => {
      if (binding.value === false) {
        return;
      }

      if (event.charCode >= 48 && event.charCode <= 57) {
        return;
      }

      event.preventDefault();
    });
  },
};
